// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 715 ? "vendors" : chunkId) + "." + {"542":"47b5b8dc6aab7fd0c95f","715":"8dac600e23bfa1982207"}[chunkId] + ".js";
};